import { endOfDay, startOfDay, format } from 'date-fns';

// Execute a promise for x time before rejecting
export function timeoutPromise<T>(
  timeout: number,
  err: Error,
  promise: Promise<T>
): Promise<T> {
  return new Promise((resolve, reject) => {
    promise.then(resolve, reject);
    setTimeout(reject.bind(null, err), timeout);
  });
}

function buildExpression({ field, operator, value }: DataFilter) {
  if (!operator) return '';

  // Filters that have no value can just return with operator
  if (operator.omitValue) return `${field} ${operator.symbol}`;

  // If no value is provided
  if (!value) return '';

  // Filter value formatting depending on type
  let filterValue;
  switch (operator.type) {
    case 'string': {
      filterValue = `'${operator.prefix ?? ''}${value.toString()}${
        operator.suffix ?? ''
      }'`;
      break;
    }
    case 'number': {
      filterValue = `${value.toString()}`;
      break;
    }
    case 'date': {
      const dateValue = value as Date;
      if (operator.fullDay) {
        const dayStart = format(startOfDay(dateValue), 'yyyy-MM-dd HH:mm:ss');
        const dayEnd = format(endOfDay(dateValue), 'yyyy-MM-dd HH:mm:ss');
        filterValue = `timestamp '${dayStart}' AND timestamp '${dayEnd}'`;
      } else {
        filterValue = `'${format(dateValue, 'yyyy-MM-dd')}'`;
      }
      break;
    }
    // no default
  }
  return `${field} ${operator.symbol} ${filterValue}`;
}

export function buildWhereStatement(filters: DataFilter[]): string {
  const whereStatementArray: string[] = [];

  for (const filter of filters) {
    const filterExpression = buildExpression(filter);
    if (filterExpression) whereStatementArray.push(filterExpression);
  }

  // Join all filters from each column
  const whereStatement = whereStatementArray.join(' AND ');

  return whereStatement;
}
